// extracted by mini-css-extract-plugin
export default {"box":"FAQ_box__gd4J9","leftBox":"FAQ_leftBox__0-JfE","heading":"FAQ_heading__L54uD","text":"FAQ_text__mNLK6","rightBox":"FAQ_rightBox__11KLY"};